import { styled } from '@material-ui/core/styles'
import Avatar from '@material-ui/core/Avatar'

export const AccountAvatarImage = styled(Avatar)(({ theme }) => ({
  width: theme.spacing(12),
  height: theme.spacing(12)
}))
